module.exports = __webpack_public_path__ + "static/media/slide3.264f0c26.jpg";